import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/5_cats-3/5_cats-3"
 * Contains 6 texture(s)
 */
export class CardsFront5Cats3Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/5_cats-3/5_cats-3';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '9-diamonds.png',
        '9-clubs.png',
        '8-spades.png',
        '8-hearts.png',
        '8-diamonds.png',
        '8-clubs.png'
    ] as const;
}
